import addMonths from 'date-fns/addMonths';
import differenceInCalendarMonths from 'date-fns/differenceInCalendarMonths';
import startOfDay from 'date-fns/startOfDay';
import CarouselSettings from 'modules/common/Navbar/popovers/AgendaPopover/CarouselSettings';
import Month from 'components/Month';
import PreviousButton from 'modules/common/Navbar/popovers/AgendaPopover/PreviousButton';
import React, { PureComponent } from 'react';
import Carousel from 'nuka-carousel';
import classnames from 'classnames';
import memoize from 'lodash.memoize';
import { TODAY } from '~/timeConstants';

const CSS = require('./MonthCarousel.less');
const today = startOfDay(new Date());

interface MonthCarouselProps {
  onSelectDate: (date: Date) => void;
  startDate: Date;
  endDate: Date;
  availableDays?: string[];
  markedDays?: string[];
  slidesToShow?: number;
}

interface MonthCarouselState {
  months: number;
  slideIndex: number;
}

class MonthCarousel extends PureComponent<MonthCarouselProps, MonthCarouselState> {
  constructor(props) {
    super(props);
    const diffInMonths = !!props.startDate ? differenceInCalendarMonths(props.startDate, TODAY) : 0;
    // +3 explained:
    //    - +1 due to 0-index start
    //    - +1 due to rendering the "right" month (the "left" month is the current month or the startDate month)
    //    - +1 due to rendering the month after the "right" month so we can click to the next months
    const months = Math.max(diffInMonths + 3, 3);
    this.state = {
      months,
      slideIndex: diffInMonths,
    };
  }

  beforeSlide = (currentSlideIndex, newSlideIndex) => {
    const newState: { slideIndex: number; months: number } = {
      slideIndex: newSlideIndex,
      months: this.state.months,
    };

    if (newSlideIndex === this.state.months - 2) {
      newState.months = this.state.months + 1;
    }

    this.setState(newState);
  };

  private convertToMap = memoize((dates?: string[]) => {
    if (!dates) { return null; }
    const m = new Map();
    dates.forEach(d => m.set(d, true));
    return m;
  });

  render() {
    const { slideIndex } = this.state;
    const { onSelectDate, startDate, endDate } = this.props;

    return (
      <Carousel
        {...CarouselSettings}
        slidesToShow={this.props.slidesToShow || CarouselSettings.slidesToShow}
        slideIndex={this.state.slideIndex}
        beforeSlide={this.beforeSlide}
        renderTopLeftControls={slideIndex === 0 ? null : PreviousButton}
        className={CSS.Carousel}
      >
        {[...Array(Math.max(this.state.months, 3)).keys()].map((month) => {
          return (
            <Month
              showDayHeader={true}
              className={
                classnames(
                  CSS.Month,
                  {
                    [CSS.LeftMonth]: (month + slideIndex) % 2 === 0,
                    [CSS.RightMonth]: (month + slideIndex) % 2 === 1,
                  })}
              key={month}
              month={addMonths(today, month)}
              onSelect={onSelectDate}
              startDate={startDate}
              endDate={endDate}
              availableDays={this.convertToMap(this.props.availableDays)}
              markedDays={this.convertToMap(this.props.markedDays)}
            />
          );
        })
        }
      </Carousel>
    );
  }
}

export default MonthCarousel;
